import { publicRequest, request } from './core.api';
import { TenantDto } from './tenants.api';

export interface CandidateInviteResultDto {
  inviteUrl: string;
  invitationSentAtUtc: string;
}

export interface CandidateInvitePublicDto {
  candidateFirstName: string;
  candidateLastName: string;
  candidateEmail: string;
  propertyAddress: string;
  landlordDisplayName: string;
  alreadyClaimed: boolean;
  portalTargetUrl: string;
}

export interface CandidateRentomaxLookupDto {
  status: string;
  hasRentomaxAccount: boolean;
  canLinkExistingAccount: boolean;
  canSendInvite: boolean;
  matchedRentomaxProvider?: string;
}

export interface CreateCandidateTenantRequest {
  propertyId: string;
  interestDate: string;
  notes?: string;
  rentomaxAction?: string;
  // Existing person:
  tenantId?: string;
  // New person:
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}

export interface UpdateCandidateTenantRequest {
  tenantId: string;
  propertyId: string;
  interestDate: string;
  notes?: string;
  status: string;
  startDate?: string;
  endDate?: string;
  rentAmount?: number;
  // Optional: update tenant personal info
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}

export const candidateTenantsApi = {
  getAll: () => request<TenantDto[]>('/candidate-tenants'),
  getByProperty: (propertyId: string) => request<TenantDto[]>(`/properties/${propertyId}/candidate-tenants`),
  getById: (id: string) => request<TenantDto>(`/candidate-tenants/${id}`),
  lookupRentomax: (email: string) => request<CandidateRentomaxLookupDto>(`/candidate-tenants/rentomax-lookup?email=${encodeURIComponent(email)}`),
  create: (data: CreateCandidateTenantRequest) => request<TenantDto>('/candidate-tenants', { method: 'POST', body: JSON.stringify(data) }),
  update: (id: string, data: UpdateCandidateTenantRequest) => request<TenantDto>(`/candidate-tenants/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  sendInvite: (id: string, message?: string) => request<CandidateInviteResultDto>(`/candidate-tenants/${id}/invite`, { method: 'POST', body: JSON.stringify({ message }) }),
  delete: (id: string) => request<void>(`/candidate-tenants/${id}`, { method: 'DELETE' }),
};

export const candidateInvitesApi = {
  getPublic: (token: string) => publicRequest<CandidateInvitePublicDto>(`/public/candidate-invites/${encodeURIComponent(token)}`),
  claim: (token: string) => request<TenantDto>(`/candidate-invites/${encodeURIComponent(token)}/claim`, { method: 'POST', body: '{}' }),
};
